<template>
  <span>
    <dashboard-isfp-psfp-kpis-geral
      :kpis="kpis"
      :loading="loadings.kpis"
      :parcela-b-loading="parcelaBLoading"
      :parcela-b-disabled="parcelaBDisabled"
      @abrir-parcela-b="$emit('abrir-parcela-b')"
    />

    <v-row dense class="mt-2">
      <v-col cols="12" md="6" class="d-flex flex-column">
        <dashboard-isfp-psfp-top10-psfp-geral
          :topPsfp="topPsfp"
          :loading="loadings.topPsfp"
          @servicoSelecionado="$emit('navegarParaDetalhamento', $event)"
        />
      </v-col>

      <v-col cols="12" md="6" class="d-flex flex-column justify-space-between">
        <dashboard-isfp-psfp-distribuicao-psfp-geral
          :distribuicao="distribuicaoPsfp"
          :loading="loadings.distribuicao"
        />

        <dashboard-isfp-psfp-contribuicao-isfp-geral
          :contribuicao="contribuicaoPonderadaTop10"
          :loading="loadings.contribuicao"
        />
      </v-col>
    </v-row>

    <v-card class="my-1" elevation="2">
      <v-card-title>
        <h5>KPIs por Empresa</h5>
      </v-card-title>
      <div
        v-if="loadings.tabelaEmpresas"
        class="d-flex align-center justify-center"
        style="height: 300px;"
      >
        <v-progress-circular indeterminate color="primary" size="32" />
      </div>
      <v-card-text v-else>
        <v-data-table
          class="mt-3"
          elevation="0"
          dense
          :headers="headersTabelaEmpresas"
          :items="kpisPorEmpresa"
          :options="{ itemsPerPage: 10 }"
          :header-props="{ sortByText: 'Ordenar Por' }"
          no-data-text="Nenhum registro disponível"
          no-results-text="Nenhum registro correspondente encontrado"
          :mobile-breakpoint="10"
        >
          <template v-slot:header.isfp_periodo="{ header }">
            <span class="d-inline-flex align-center">
              {{ header.text }}
              <dashboard-isfp-psfp-faixas-info
                title="Faixas de valores do ISFP Período"
              />
            </span>
          </template>
          <template v-slot:item.empresa="{ item }">
            {{ item.empresa && item.empresa.name ? item.empresa.name : "-" }}
          </template>
          <template v-slot:item.isfp_periodo="{ item }">
            <span
              :style="{
                color: getCorIsfpPsfpPorValor(item.isfp_periodo),
                fontWeight: 'bold',
              }"
            >
              {{ item.isfp_periodo | parseNumberToFloatBrIgnoringNaN }} %
            </span>
          </template>
          <template v-slot:item.sa_total="{ item }">
            {{ item.sa_total | parseNumberToFloatBrIgnoringNaN }}
          </template>
          <template v-slot:item.sfp_total="{ item }">
            {{ item.sfp_total | parseNumberToFloatBrIgnoringNaN }}
          </template>
          <template v-slot:item.qisfp="{ item }">
            <span v-if="item.qisfp">
              <span
                :style="{
                  color: getCorIsfpPsfpPorValor(item.qisfp.isfp_referencia),
                  fontWeight: 'bold',
                }"
              >
                {{ item.qisfp.valor | parseNumberToFloatBrIgnoringNaN }} %
              </span>
              <div
                class="caption"
                :style="{
                  color: getCorIsfpPsfpPorValor(item.qisfp.isfp_referencia),
                }"
              >
                {{ item.qisfp.faixa }}
              </div>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.valor_financeiro="{ item }">
            <span
              v-if="
                item.valor_financeiro !== null &&
                  item.valor_financeiro !== undefined
              "
            >
              R$ {{ item.valor_financeiro | parseNumberToFloatBrIgnoringNaN }}
            </span>
            <span v-else class="grey--text caption">—</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import DashboardIsfpPsfpService from "@/services/DashboardIsfpPsfpService";
import DashboardIsfpPsfpFaixasInfo from "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpFaixasInfo.vue";
import { getCorIsfpPsfpPorValor } from "@/utils/isfpPsfpFaixas";

export default {
  name: "DashboardIsfpPsfpGeral",
  components: {
    DashboardIsfpPsfpFaixasInfo,
    DashboardIsfpPsfpKpisGeral: () =>
      import("@/components/dashboardIsfpPsfp/DashboardIsfpPsfpKpisGeral.vue"),
    DashboardIsfpPsfpTop10PsfpGeral: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpTop10PsfpGeral.vue"
      ),
    DashboardIsfpPsfpDistribuicaoPsfpGeral: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpDistribuicaoPsfpGeral.vue"
      ),
    DashboardIsfpPsfpContribuicaoIsfpGeral: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpContribuicaoIsfpGeral.vue"
      ),
  },
  props: {
    competencia: { type: String, required: true },
    modoPeriodo: { type: String, default: "12m" },
    ano: { type: Number, default: null },
    activatedTab: { type: Number, required: true },
    reloadKey: { type: Number, default: 0 },
    parcelaBLoading: { type: Boolean, default: false },
    parcelaBDisabled: { type: Boolean, default: false },
  },
  data: () => ({
    kpis: {},
    topPsfp: [],
    distribuicaoPsfp: [],
    contribuicaoPonderadaTop10: [],
    kpisPorEmpresa: [],
    loadings: {
      kpis: false,
      topPsfp: false,
      distribuicao: false,
      contribuicao: false,
      tabelaEmpresas: false,
    },
  }),
  computed: {
    headersTabelaEmpresas() {
      return [
        {
          text: "Empresa",
          value: "empresa",
          align: "start",
          sortable: false,
        },
        {
          text: "ISFP Período",
          value: "isfp_periodo",
          align: "end",
        },
        {
          text: "SA Total",
          value: "sa_total",
          align: "end",
        },
        {
          text: "SFP Total",
          value: "sfp_total",
          align: "end",
        },
        {
          text: "QISFP",
          value: "qisfp",
          align: "end",
        },
        {
          text: "Valor Financeiro",
          value: "valor_financeiro",
          align: "end",
        },
      ];
    },
  },
  mounted() {
    this.getDados();
  },
  methods: {
    formatarPercentualComSinal(valor) {
      if (valor === null || valor === undefined || isNaN(valor)) return "-";

      const numero = Number(valor);
      const sinal = numero > 0 ? "+" : numero < 0 ? "-" : "";
      const absoluto = Math.abs(numero)
        .toFixed(2)
        .replace(".", ",");

      return `${sinal}${absoluto}%`;
    },
    getCorIsfpPsfpPorValor,
    getDados() {
      if (this.activatedTab !== 0) return;

      this.$emit("updateLoadingDados", true);
      Object.keys(this.loadings).forEach((k) => (this.loadings[k] = true));

      DashboardIsfpPsfpService.getDadosTela1VisaoGeral(
        this.competencia,
        this.modoPeriodo,
        this.ano,
      )
        .then((res) => {
          this.kpis = res.kpis;
          this.loadings.kpis = false;

          this.topPsfp = res.top_psfp;
          this.loadings.topPsfp = false;

          this.distribuicaoPsfp = res.distribuicao_psfp;
          this.loadings.distribuicao = false;

          this.contribuicaoPonderadaTop10 = res.contribuicao_ponderada_top10;
          this.loadings.contribuicao = false;

          this.kpisPorEmpresa = res.kpis_por_empresa || [];
          this.loadings.tabelaEmpresas = false;
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados.", "", {
            position: "topRight",
          });
        })
        .finally(() => {
          Object.keys(this.loadings).forEach((k) => (this.loadings[k] = false));
          this.$emit("updateLoadingDados", false);
        });
    },
  },
  watch: {
    activatedTab() {
      this.getDados();
    },
    competencia() {
      this.getDados();
    },
    modoPeriodo() {
      this.getDados();
    },
    ano() {
      this.getDados();
    },
    reloadKey() {
      this.getDados();
    },
  },
};
</script>

<style></style>
